import React from 'react';
import { Text } from '@wegroup/design-system';

// Components
import AccidentsInput from './AccidentsInput';

// Types
import { Change } from '../../../../../../../types/Form';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';

export interface PiaClaim {
  cause: string;
  loss_amount: string;
  year: string;
}

interface Props {
  question: FlowsQuestion;
}

const PiaClaimsInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({ question });

  const accidents = (value as PiaClaim[] | undefined) || [];

  const handleChange = async (e: Change) => {
    await onBlur(e);
  };

  return (
    <>
      {error && (
        <Text mb="4" color="danger.main">
          {error?.message}
        </Text>
      )}
      <AccidentsInput
        name={question.id}
        accidents={accidents}
        handleChange={handleChange}
      />
    </>
  );
};
export default PiaClaimsInputComponent;
